import { BaseService } from '../api/services/base-service';
import { FilteredRequest } from '../common/interfaces';
import { ActionReason, ReasonsRequest, ListApplicationsRequest, Application } from './common-admin.service.interfaces';

export class CommonAdminService extends BaseService {
  listReasons(req: FilteredRequest<ReasonsRequest>) {
    return this.get<ActionReason[]>(`${this.apiUrl}/common-admin/v1/reasons/list`, req);
  }

  listApplications(req: FilteredRequest<ListApplicationsRequest>) {
    return this.get<Application[]>(`${this.apiUrl}/common-admin/v1/applications/list`, req);
  }
}
